import BabylistBabes from './babylist-babes'

export default BabylistBabes
